package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.objects

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.ObjectKindTypes
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.ObjectKinds
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Furniture
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.RestaurantObject
import org.hs_soft.runmynesto.pages.components.Separator
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun Indicators(
    onSubmitClick:(ObjectKinds)->Unit,
) {

    val furniture= remember { mutableStateOf<Furniture?>(null) }
    val selectedItem= remember { mutableStateOf<ObjectKinds?>(null) }
    val isExpanded= remember { mutableStateOf(false) }

    Column(
        modifier = Modifier
            .borderRadius(Dimen.lowBorderRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
            .fillMaxWidth()
            .margin(top = Dimen.normalPadding)
    )
    {
        RestaurantProjectObjectHeader(
            isExpanded =isExpanded.value ,
            title=Strings.current().indicators,
            onItemClick = {
                isExpanded.value=!isExpanded.value
            }
        )
        if (isExpanded.value) {

            Column(
                modifier = Modifier
                    .padding(
                        bottom = Dimen.largePadding,
                    )
                    .fillMaxWidth()
            )
            {

                Separator(
                    modifier = Modifier
                        .margin(bottom = Dimen.largePadding)
                )

                Column(
                    modifier = Modifier
                        .margin(left = Dimen.largePadding)
                )
                {
                    ObjectKinds.entries.filter {
                        it.type== ObjectKindTypes.INDICATOR
                    }.chunked(3).forEach {row ->
                        Row()
                        {
                            row.forEach {
                                RestaurantObject(
                                    selectedFurniture =furniture.value ,
                                    objectInfo = it,
                                    onClick = {
                                        furniture.value= Furniture(
                                            shape = it.shape?.value,
                                            objectKind =it.value,
                                            width = it.width,
                                            height = it.height,
                                        )
                                        selectedItem.value=it
                                    }
                                )

                            }
                        }

                    }

                    CustomButton(
                        modifier = Modifier
                            .margin(topBottom = Dimen.normalPadding),
                        title = Strings.current().add,
                        isClickable = selectedItem.value!=null,
                        buttonType = ButtonTypes.CONTAINED,
                        onButtonClick = {
                            selectedItem.value?.let {
                                onSubmitClick(it)
                            }
                        },
                    )
                }


            }
        }




    }


}